import { render } from "./CtaFinal.vue?vue&type=template&id=448fc366&scoped=true"
const script = {}

import "./CtaFinal.vue?vue&type=style&index=0&id=448fc366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448fc366"]])

export default __exports__